import BaseService from '../BaseService';
import api from '../../services/api';

const RECURSO_DOCUMENTOS = '/atendimentos/diagnostico/documentos/';

class DiagnosticoService extends BaseService {
    constructor() {
        super('/atendimentos/diagnostico/');
    }

    listar(atendimentoId) {
        return this.getAll({ atendimento_id: atendimentoId });
    }

    enviarDocumento(diagnosticoId, tipo, descricao, arquivo) {
        const formData = new FormData();
        formData.append('beneficiario_doenca_id', diagnosticoId);
        formData.append('tipo', tipo);
        formData.append('arquivo', arquivo);

        if (descricao) {
            formData.append('descricao', descricao);
        }

        return api.post(RECURSO_DOCUMENTOS, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }

    excluirDocumento(documentoId) {
        return api.delete(`${RECURSO_DOCUMENTOS}${documentoId}/`);
    }
}

const buscarPatologias = async (nome = '') => {
    try {
        const response = await api.get('/doencas/', { params: { nome } });
        const dados = response.data?.results || response.data || [];

        return Array.isArray(dados) ? dados : [];
    } catch (error) {
        console.error('Erro ao carregar patologias:', error);
        return [];
    }
};

const cadastrarPatologia = (nome, cidId) => api.post('/doencas/', { nome, cid_id: cidId });

const buscarCids = async (busca = '') => {
    try {
        const response = await api.get('/doencas/cids/', { params: { busca } });
        const dados = response.data?.results || response.data || [];

        return Array.isArray(dados) ? dados : [];
    } catch (error) {
        console.error('Erro ao carregar CIDs:', error);
        return [];
    }
};

const diagnosticoService = new DiagnosticoService();

diagnosticoService.buscarPatologias = buscarPatologias;
diagnosticoService.cadastrarPatologia = cadastrarPatologia;
diagnosticoService.buscarCids = buscarCids;

export default diagnosticoService;
